import { render, staticRenderFns } from "./UniversalSelectInput.vue?vue&type=template&id=58d37ee2&"
import script from "./UniversalSelectInput.vue?vue&type=script&lang=ts&"
export * from "./UniversalSelectInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports